module.exports = __webpack_public_path__ + "static/media/arroRight.8d1fbb62.png";